import { isPossiblePhoneNumber, isValidNumber, parsePhoneNumber } from 'libphonenumber-js';

export const parseMobile = (mobile: string) => {
  if (!mobile) {
    return mobile;
  }
  if (isValidMobile(mobile)) {
    const parsedMobile = parsePhoneNumber(mobile, 'ZA');
    return parsedMobile.formatInternational();
  }
  return mobile;
};

export const isPossibleMobile = (value: string) => {
  return isPossiblePhoneNumber(value, 'ZA');
};

export const isValidMobile = (mobile: string) => {
  if (!mobile) {
    return false;
  }
  return isValidNumber(mobile, 'ZA');
};

export const isValidEmail = (email: string) => {
  const trimmedEmail = email.trim();
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const emailTest = re.test(String(trimmedEmail).toLowerCase());
  if (!emailTest) {
    return false;
  } else {
    return true;
  }
};

export const isSafeText = (text: string): boolean => {
  const safeTextRegex = /^[a-zA-Z0-9 _-]+$/;
  return safeTextRegex.test(text);
};

export const onlyNumberKey = (e: any) => {
  const char = String.fromCharCode(e.keyCode);
  if (/^[0-9]+$/.test(char)) return true;
  e.preventDefault();
  return false;
};

export const isValidPassword = (password: string, confirmPassword: string) => {
  const validationResponse = {
    isValid: false,
    errorMessage: '',
  };
  if (password.length < 8) {
    validationResponse.errorMessage = 'Password length should be 8 or more characters.';
  } else if (password !== confirmPassword) {
    validationResponse.errorMessage = 'Passwords do not match.';
  } else {
    validationResponse.isValid = true;
  }
  return validationResponse;
};

export const maskEmail = (email: string | undefined): string => {
  if (!email) return '';
  const emailParts = email.split('@');
  if (emailParts.length !== 2) return email; // Return original email if it's not in a valid format

  const [localPart, domain] = emailParts;
  const maskedLocalPart =
    localPart.length > 2 ? `${localPart[0]}${'*'.repeat(localPart.length - 2)}${localPart.slice(-1)}` : localPart;

  return `${maskedLocalPart}@${domain}`;
};

export const isNumber = (event: Event): string => {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^0-9]/g, '');
  return input.value;
};
